import { useState } from "react";
import emailjs from "@emailjs/browser";
import footerlogo from "../assets/images/logo.png";
import SEO from "../components/SEO";

// ─── EmailJS Config ──────────────────────────────────────────────
// 1. Sign up at https://www.emailjs.com (free)
// 2. Add Gmail service connected to hospitalsdesigners@gmail.com
// 3. Create a template using the variables listed below
// 4. Paste your IDs here
const EMAILJS_SERVICE_ID  = "YOUR_SERVICE_ID";   // e.g. "service_abc123"
const EMAILJS_TEMPLATE_ID = "YOUR_TEMPLATE_ID";  // e.g. "template_xyz789"
const EMAILJS_PUBLIC_KEY  = "YOUR_PUBLIC_KEY";   // e.g. "aBcDeFgHiJkLmNoP"
// ─────────────────────────────────────────────────────────────────
// Template variables to use in your EmailJS template:
// {{first_name}}, {{last_name}}, {{email}}, {{phone}},
// {{company}}, {{service}}, {{date}}, {{time}}, {{mode}},
// {{budget}}, {{topics}}, {{message}}, {{submitted_at}}
// ─────────────────────────────────────────────────────────────────

// ─── LOGO ─────────────────────────────────────────────────────────
// Replace this with your logo image URL (e.g. an uploaded image link,
// or paste a base64 data URI here). Leave blank to keep the placeholder.
const LOGO_URL = footerlogo; // e.g. "https://yourdomain.com/logo.png"
// ─────────────────────────────────────────────────────────────────

// ─── WhatsApp number to receive submissions ───────────────────────
// Include the country code, no spaces, no plus sign (e.g. 91 for India)
const WHATSAPP_NUMBER = "919993999840";
// ─────────────────────────────────────────────────────────────────

const SERVICES = [
  { value: "",           label: "Select a service"           },
  { value: "Architects & Construction",        label: "Architects & Construction"        },
  { value: "Interior Design with Plug and Play", label: "Interior Design with Plug and Play" },
  { value: "Project Management Consultant (PMC)", label: "Project Management Consultant (PMC)" },
  { value: "Express Renovation",                label: "Express Renovation"                },
  { value: "NABH Consultant",                    label: "NABH Consultant"                    },
  { value: "Medical Furniture",                  label: "Medical Furniture"                  },
  { value: "Other",                              label: "Other"                              },
];

const TIME_SLOTS = [
  "09:00 – 10:00","10:00 – 11:00","11:00 – 12:00",
  "14:00 – 15:00","15:00 – 16:00","16:00 – 17:00",
];

const MEETING_FORMATS = [
  "Video call (Google Meet)",
  "Video call (Zoom)",
  "Phone call",
  "In-person",
];

const HOSPITAL_CATEGORIES = [
  "Clinic",
  "Day care center",
  "Nursing Home",
  "Single specialty",
  "Multispecialty",
  "Super specialty",
];

const MUNICIPAL_NORMS = ["As per Municipal Norms", "Not as per Municipal Norms", "Not sure"];

const DEPARTMENTS = [
  "Cardiology", "Neurology", "Nephrology & Urology", "Gastroenterology",
  "Pulmonology", "Orthopedics", "Emergency & Trauma", "General Medicine",
  "Gynecology & Obstetrics", "Pediatrics", "Oncology",
];

const RADIOLOGY_OPTIONS = ["X-ray", "CT", "MRI", "Cath Lab", "Ultrasound", "ECG", "TMT"];
const LAB_OPTIONS = ["Bio Chemistry", "Micro Biology", "Pathology"];
const PHARMACY_OPTIONS = ["Inpatient", "Outpatient", "Both"];
const NON_CLINICAL_OPTIONS = ["Administrative offices", "Conference / teaching halls", "Cafeteria / Canteen", "Nurse's hostel"];

const BUDGET_LABELS = ["Under ₹50k","₹50k – ₹1L","₹1L – ₹2L","₹2L – ₹5L","₹5L+"];

const TOPICS = [
  "Initial scoping & requirements",
  "Pricing & contract terms",
  "Technical feasibility",
  "Timeline & milestones",
];



function logoBoxStyle(hasLogo) {
  return {
    width: 56, height: 56, borderRadius: 10, flexShrink: 0,
    background: hasLogo ? "#fff" : "#1a1a1a",
    border: hasLogo ? "1px solid #2a2a2a" : "1.5px dashed #444",
    padding: hasLogo ? 6 : 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    overflow: "hidden", boxSizing: "border-box",
  };
}

const s = {
  card: { background: "#fff", borderRadius: 18, width: "100%", overflow: "hidden", fontFamily: "'Poppins',sans-serif"},
  header: { background: "#111", padding: "1.5rem 2rem", borderBottom: "1px solid #2a2a2a", display: "flex", alignItems: "flex-start", gap: 16 },
  headerText: { flex: 1, minWidth: 0 },
  logoPlaceholderText: { fontSize: 9, color: "#777", textAlign: "center", lineHeight: 1.3, fontWeight: 600, letterSpacing: "0.04em" },
  brandRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 },
  brandName: { fontSize: 12, fontWeight: 600, color: "#bbb", letterSpacing: "0.06em", textTransform: "uppercase" },
  title: { fontSize: 20, fontWeight: 600, color: "#fff", marginBottom: 4, letterSpacing: "-0.3px" },
  subtitle: { fontSize: 13, color: "#888", lineHeight: 1.5 },
  body: { padding: "1.75rem 2rem" },
  sectionLabel: { fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", color: "#aaa", textTransform: "uppercase", marginBottom: "0.875rem", paddingBottom: 8, borderBottom: "1px solid #f0f0f0" },
  section: { marginBottom: "1.5rem" },
  row2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.875rem", marginBottom: "0.875rem" },
  row3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.875rem", marginBottom: "0.875rem" },
  row1: { display: "grid", gridTemplateColumns: "1fr", marginBottom: "0.875rem" },
  field: { display: "flex", flexDirection: "column", gap: 5 },
  label: { fontSize: 12.5, fontWeight: 500, color: "#2a2a2a", display: "flex", alignItems: "center", gap: 3 },
  required: { color: "#e53535", fontSize: 13, lineHeight: 1 },
  optText: { color: "#bbb", fontWeight: 400, fontSize: 11, marginLeft: 4 },
  errorText: { fontSize: 11, color: "#e53535", marginTop: 2 },
  budgetChip: { display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: 99, fontSize: 11, background: "#1a1a1a", color: "#fff", marginLeft: 8, fontWeight: 500 },
  budgetLabels: { display: "flex", justifyContent: "space-between", marginTop: 4, fontSize: 10, color: "#ccc" },
  checkRow: { display: "flex", alignItems: "center", gap: 9, cursor: "pointer", padding: "5px 0", userSelect: "none" },
  checkText: { fontSize: 13, color: "#444" },
  checkGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px 14px" },
  charCount: { fontSize: 11, color: "#ccc", textAlign: "right", marginTop: 4 },
  footer: { background: "#f6f6f6", borderTop: "1px solid #eaeaea", padding: "1.125rem 2rem", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem" },
  footerNote: { fontSize: 12, color: "#aaa", display: "flex", alignItems: "center", gap: 5 },
  successBar: { background: "#1a1a1a", color: "#fff", fontSize: 13, padding: "14px 2rem", display: "flex", alignItems: "center", gap: 10 },
  errorBar: { background: "#fff0f0", color: "#c0392b", fontSize: 13, padding: "12px 2rem", display: "flex", alignItems: "center", gap: 10, borderBottom: "1px solid #ffd5d5" },
};

function inputStyle(focused, hasError) {
  return {
    width: "100%", background: focused ? "#fff" : "#f7f7f7",
    border: hasError ? "1.5px solid #e53535" : focused ? "1px solid #555" : "1px solid #e4e4e4",
    borderRadius: 8, padding: "9px 12px", fontSize: 13.5, color: "#1a1a1a",
    outline: "none", fontFamily: "'Poppins',sans-serif",
    boxShadow: focused && !hasError ? "0 0 0 3px rgba(0,0,0,0.06)" : hasError ? "0 0 0 3px rgba(229,53,53,0.08)" : "none",
    transition: "border 0.15s, box-shadow 0.15s",
  };
}

function selectStyle(focused, hasError) {
  return {
    ...inputStyle(focused, hasError),
    padding: "9px 34px 9px 12px", appearance: "none", cursor: "pointer",
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat", backgroundPosition: "right 10px center", backgroundSize: "14px",
  };
}

function textareaStyle(focused, hasError) {
  return { ...inputStyle(focused, hasError), resize: "vertical", minHeight: 88, lineHeight: 1.6 };
}

function FocusInput({ as: Tag = "input", hasError, ...props }) {
  const [focused, setFocused] = useState(false);
  const style =
    Tag === "textarea" ? textareaStyle(focused, hasError)
    : Tag === "select" ? selectStyle(focused, hasError)
    : inputStyle(focused, hasError);
  return (
    <Tag {...props} style={style}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)} />
  );
}

function Field({ label, required, optional, error, children }) {
  return (
    <div style={s.field}>
      <label style={s.label}>
        {label}
        {required && <span style={s.required}>*</span>}
        {optional && <span style={s.optText}>(optional)</span>}
      </label>
      {children}
      {error && <div style={s.errorText}>⚠ {error}</div>}
    </div>
  );
}

function CheckGroup({ options, selected, onToggle, columns = 2 }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: "2px 14px" }}>
      {options.map((opt) => {
        const checked = selected.includes(opt);
        return (
          <div key={opt} style={s.checkRow} onClick={() => onToggle(opt)}>
            <div style={{
              width: 17, height: 17, borderRadius: 4, flexShrink: 0,
              border: checked ? "none" : "1.5px solid #ccc",
              background: checked ? "#1a1a1a" : "#f7f7f7",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 11, color: "#fff", transition: "all 0.15s",
            }}>
              {checked && "✓"}
            </div>
            <span style={s.checkText}>{opt}</span>
          </div>
        );
      })}
    </div>
  );
}

const EMPTY_FORM = {
  firstName: "", lastName: "", email: "", phone: "",
  // 1. General information
  hospitalName: "", plotLength: "", plotWidth: "", roadSize: "", facingDirection: "",
  plotArea: "", municipalNorms: "", hospitalCategory: "",
  // 2. Specialization departments
  otherDepartment: "",
  // 3. Capacity & bed strength
  totalBeds: "", generalWardBeds: "", specialRooms: "", deluxeRooms: "", suiteRooms: "",
  sharingRooms: "", isolationRooms: "", micuBeds: "", picuBeds: "", nicuBeds: "",
  // 4. Outpatient & emergency
  opdRooms: "", emergencyBeds: "",
  // 5. Operation theatres
  totalOT: "", laminarOT: "", modularOT: "", minorOT: "",
  // 6. Diagnostics & support — others
  otherRadiology: "",
  // 8. Parking
  parkingCars: "", parkingBikes: "", parkingAmbulances: "",
  // Consultation booking
  service: "", date: "", time: "", mode: "",
  budget: 1, message: "",
};

export default function ConsultationForm() {
  const [form,      setForm]      = useState(EMPTY_FORM);
  const [topics,    setTopics]    = useState([false, false, false, false]);
  const [departments, setDepartments]   = useState([]);
  const [radiology,   setRadiology]     = useState([]);
  const [labs,        setLabs]          = useState([]);
  const [pharmacy,    setPharmacy]      = useState([]);
  const [nonClinical, setNonClinical]   = useState([]);
  const [errors,    setErrors]    = useState({});
  const [loading,   setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [sendError, setSendError] = useState("");

  const makeToggle = (setter) => (opt) =>
    setter((list) => list.includes(opt) ? list.filter((o) => o !== opt) : [...list, opt]);

  const toggleDept        = makeToggle(setDepartments);
  const toggleRadiology   = makeToggle(setRadiology);
  const toggleLab         = makeToggle(setLabs);
  const togglePharmacy    = makeToggle(setPharmacy);
  const toggleNonClinical = makeToggle(setNonClinical);

  const set = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    if (errors[key]) setErrors((prev) => { const n = { ...prev }; delete n[key]; return n; });
  };

  const toggleTopic = (i) => setTopics((t) => t.map((v, idx) => (idx === i ? !v : v)));

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim())  errs.firstName = "First name is required";
    if (!form.lastName.trim())   errs.lastName  = "Last name is required";
    if (!form.email.trim())      errs.email     = "Email address is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = "Enter a valid email address";
    if (!form.phone.trim())      errs.phone     = "Phone number is required";
    else if (!/^[+\d\s\-()]{7,}$/.test(form.phone)) errs.phone = "Enter a valid phone number";
    if (!form.service)           errs.service   = "Please select a service";
    if (!form.date)              errs.date      = "Please select a preferred date";
    if (!form.time)              errs.time      = "Please select a time slot";
    if (!form.mode)              errs.mode      = "Please select a meeting format";
    return errs;
  };

  const handleSubmit = async () => {
    setSendError("");
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      // Scroll to first error
      const firstKey = Object.keys(errs)[0];
      const el = document.getElementById(`cf_${firstKey}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setLoading(true);

    const templateParams = {
      first_name:        form.firstName,
      last_name:         form.lastName,
      email:             form.email,
      phone:             form.phone,

      hospital_name:       form.hospitalName || "—",
      plot_dimensions:     `Length: ${form.plotLength || "—"}, Width: ${form.plotWidth || "—"}, Road size: ${form.roadSize || "—"}, Facing: ${form.facingDirection || "—"}`,
      plot_area:           form.plotArea || "—",
      municipal_norms:     form.municipalNorms || "—",
      hospital_category:   form.hospitalCategory || "—",

      departments:         (departments.join(", ") || "None selected") + (form.otherDepartment ? `, Other: ${form.otherDepartment}` : ""),

      total_beds:          form.totalBeds || "—",
      general_ward_beds:   form.generalWardBeds || "—",
      special_rooms:       `Special: ${form.specialRooms || "—"}, Deluxe: ${form.deluxeRooms || "—"}, Suite: ${form.suiteRooms || "—"}`,
      sharing_rooms:       form.sharingRooms || "—",
      isolation_rooms:     form.isolationRooms || "—",
      icu_beds:            `MICU: ${form.micuBeds || "—"}, PICU: ${form.picuBeds || "—"}, NICU: ${form.nicuBeds || "—"}`,

      opd_rooms:           form.opdRooms || "—",
      emergency_beds:      form.emergencyBeds || "—",

      operation_theatres:  `Total: ${form.totalOT || "—"}, Laminar: ${form.laminarOT || "—"}, Modular: ${form.modularOT || "—"}, Minor: ${form.minorOT || "—"}`,

      radiology:           (radiology.join(", ") || "None selected") + (form.otherRadiology ? `, Other: ${form.otherRadiology}` : ""),
      laboratory:          labs.join(", ") || "None selected",
      pharmacy:            pharmacy.join(", ") || "None selected",
      non_clinical_areas:  nonClinical.join(", ") || "None selected",
      parking:             `Cars: ${form.parkingCars || "—"}, Bikes: ${form.parkingBikes || "—"}, Ambulances: ${form.parkingAmbulances || "—"}`,

      service:           form.service,
      date:              form.date,
      time:              form.time,
      mode:              form.mode,
      budget:            BUDGET_LABELS[form.budget],
      topics:            TOPICS.filter((_, i) => topics[i]).join(", ") || "None selected",
      message:           form.message || "—",
      submitted_at:      new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
    };

    // ── Build a readable WhatsApp summary ────────────────────────
    const waLines = [
      `*New consultation request*`,
      ``,
      `*Name:* ${form.firstName} ${form.lastName}`,
      `*Email:* ${form.email}`,
      `*Phone:* ${form.phone}`,
      ``,
      `*Hospital:* ${form.hospitalName || "—"}`,
      `*Category:* ${form.hospitalCategory || "—"}`,
      `*Plot area:* ${form.plotArea || "—"}`,
      `*Plot dims:* L:${form.plotLength || "—"} W:${form.plotWidth || "—"} Road:${form.roadSize || "—"} Facing:${form.facingDirection || "—"}`,
      `*Municipal norms:* ${form.municipalNorms || "—"}`,
      ``,
      `*Departments:* ${templateParams.departments}`,
      `*Total beds:* ${form.totalBeds || "—"} | *General ward:* ${form.generalWardBeds || "—"}`,
      `*Rooms:* ${templateParams.special_rooms}`,
      `*Sharing rooms:* ${form.sharingRooms || "—"} | *Isolation rooms:* ${form.isolationRooms || "—"}`,
      `*ICU:* ${templateParams.icu_beds}`,
      ``,
      `*OPD rooms:* ${form.opdRooms || "—"} | *Emergency beds:* ${form.emergencyBeds || "—"}`,
      `*OT:* ${templateParams.operation_theatres}`,
      ``,
      `*Radiology:* ${templateParams.radiology}`,
      `*Laboratory:* ${templateParams.laboratory}`,
      `*Pharmacy:* ${templateParams.pharmacy}`,
      `*Non-clinical areas:* ${templateParams.non_clinical_areas}`,
      `*Parking:* ${templateParams.parking}`,
      ``,
      `*Service requested:* ${form.service}`,
      `*Preferred date:* ${form.date}`,
      `*Preferred time:* ${form.time}`,
      `*Meeting format:* ${form.mode}`,
      `*Budget:* ${templateParams.budget}`,
      `*Topics:* ${templateParams.topics}`,
      `*Message:* ${form.message || "—"}`,
      ``,
      `_Submitted: ${templateParams.submitted_at}_`,
    ];
    const waText = encodeURIComponent(waLines.join("\n"));
    const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${waText}`;

	  try {
    await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        { publicKey: EMAILJS_PUBLIC_KEY }
    );
      window.open(waUrl, "_blank");
      setLoading(false);
      setSubmitted(true);
    } catch (err) {
      console.error("EmailJS error:", err);
      // Still let the person send the WhatsApp message even if email failed
      window.open(waUrl, "_blank");
      setLoading(false);
      setSendError("Couldn't send the confirmation email, but your WhatsApp message has been opened — please hit send there, or reach us directly at hospitalsdesigners@gmail.com");
    }
  };

  if (submitted) {
    return (
      <>
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />
        <div style={{ ...s.card, minHeight: 320, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "3rem 2rem", textAlign: "center", gap: 16 }}>
          <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#111", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>✓</div>
          <div style={{ fontSize: 20, fontWeight: 600, color: "#111" }}>Request submitted!</div>
          <div style={{ fontSize: 14, color: "#777", maxWidth: 360, lineHeight: 1.6 }}>
            Thank you, <strong>{form.firstName}</strong>. A confirmation has been sent to <strong>{form.email}</strong>.<br />
            Our team will reach out within 24 hours.
          </div>
          <button
            onClick={() => { setForm(EMPTY_FORM); setTopics([false,false,false,false]); setDepartments([]); setRadiology([]); setLabs([]); setPharmacy([]); setNonClinical([]); setSubmitted(false); }}
            style={{ marginTop: 8, background: "none", border: "1px solid #ddd", borderRadius: 8, padding: "8px 20px", fontSize: 13, color: "#555", cursor: "pointer", fontFamily: "'Poppins',sans-serif", }}
          >
            Submit another request
          </button>
        </div>
      </>
    );
  }

  return (
     <>
    <SEO/>
    <>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />
      <div style={s.card}>

        {sendError && (
          <div style={s.errorBar}>
            <span>⚠</span> {sendError}
          </div>
        )}

        <div style={s.header}>
          {/* ── Logo placeholder — replace LOGO_URL above, or swap this box for your own <img> ── */}
          <div style={logoBoxStyle(!!LOGO_URL)}>
            {LOGO_URL ? (
              <img src={LOGO_URL} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            ) : (
              <span style={s.logoPlaceholderText}>YOUR<br/>LOGO</span>
            )}
          </div>
          <div style={s.headerText}>
            <div style={s.brandRow}>
              <span style={s.brandName}>PR Hospital Designers</span>
            </div>
            <div style={s.title}>Book a free consultation</div>
            <div style={s.subtitle}>
              Fields marked <span style={{ color: "#e87070" }}>*</span> are required. We'll contact you within 24 hours.
            </div>
          </div>
        </div>

        <div style={s.body}>

          {/* Personal information */}
          <div style={s.section}>
            <div style={s.sectionLabel}>Personal information</div>
            <div style={s.row2}>
              <Field label="First name" required error={errors.firstName}>
                <FocusInput id="cf_firstName" placeholder="Ravi" value={form.firstName} onChange={set("firstName")} hasError={!!errors.firstName} />
              </Field>
              <Field label="Last name" required error={errors.lastName}>
                <FocusInput id="cf_lastName" placeholder="Kumar" value={form.lastName} onChange={set("lastName")} hasError={!!errors.lastName} />
              </Field>
            </div>
            <div style={s.row2}>
              <Field label="Email address" required error={errors.email}>
                <FocusInput id="cf_email" type="email" placeholder="ravi@hospital.com" value={form.email} onChange={set("email")} hasError={!!errors.email} />
              </Field>
              <Field label="Phone number" required error={errors.phone}>
                <FocusInput id="cf_phone" type="tel" placeholder="+91 98765 43210" value={form.phone} onChange={set("phone")} hasError={!!errors.phone} />
              </Field>
            </div>
          </div>

          {/* 1. General information */}
          <div style={s.section}>
            <div style={s.sectionLabel}>1. General information</div>
            <div style={s.row1}>
              <Field label="Name of the hospital" optional>
                <FocusInput placeholder="e.g. Sravan Hospital" value={form.hospitalName} onChange={set("hospitalName")} />
              </Field>
            </div>
            <div style={s.row3}>
              <Field label="Plot length" optional>
                <FocusInput placeholder="ft" value={form.plotLength} onChange={set("plotLength")} />
              </Field>
              <Field label="Plot width" optional>
                <FocusInput placeholder="ft" value={form.plotWidth} onChange={set("plotWidth")} />
              </Field>
              <Field label="Road size" optional>
                <FocusInput placeholder="ft" value={form.roadSize} onChange={set("roadSize")} />
              </Field>
            </div>
            <div style={s.row2}>
              <Field label="Direction of facing" optional>
                <FocusInput placeholder="e.g. East" value={form.facingDirection} onChange={set("facingDirection")} />
              </Field>
              <Field label="Total plot area" optional>
                <FocusInput placeholder="e.g. 5000 sq.ft" value={form.plotArea} onChange={set("plotArea")} />
              </Field>
            </div>
            <div style={s.row2}>
              <Field label="As per municipal norms?" optional>
                <FocusInput as="select" value={form.municipalNorms} onChange={set("municipalNorms")}>
                  <option value="">Select an option</option>
                  {MUNICIPAL_NORMS.map((m) => <option key={m}>{m}</option>)}
                </FocusInput>
              </Field>
              <Field label="Hospital category" optional>
                <FocusInput as="select" value={form.hospitalCategory} onChange={set("hospitalCategory")}>
                  <option value="">Select a category</option>
                  {HOSPITAL_CATEGORIES.map((c) => <option key={c}>{c}</option>)}
                </FocusInput>
              </Field>
            </div>
          </div>

          {/* 2. Specialization departments */}
          <div style={s.section}>
            <div style={s.sectionLabel}>2. Specialization departments</div>
            <Field label="Which clinical departments are required?" optional>
              <CheckGroup options={DEPARTMENTS} selected={departments} onToggle={toggleDept} columns={2} />
            </Field>
            <div style={{ marginTop: 10 }}>
              <Field label="Others (please specify)" optional>
                <FocusInput placeholder="e.g. Dermatology" value={form.otherDepartment} onChange={set("otherDepartment")} />
              </Field>
            </div>
          </div>

          {/* 3. Capacity & bed strength */}
          <div style={s.section}>
            <div style={s.sectionLabel}>3. Capacity & bed strength</div>
            <div style={s.row2}>
              <Field label="Total number of beds required" optional>
                <FocusInput placeholder="e.g. 50" value={form.totalBeds} onChange={set("totalBeds")} />
              </Field>
              <Field label="Number of general ward beds" optional>
                <FocusInput placeholder="e.g. 20" value={form.generalWardBeds} onChange={set("generalWardBeds")} />
              </Field>
            </div>
            <div style={s.row3}>
              <Field label="Special rooms" optional>
                <FocusInput placeholder="count" value={form.specialRooms} onChange={set("specialRooms")} />
              </Field>
              <Field label="Deluxe rooms" optional>
                <FocusInput placeholder="count" value={form.deluxeRooms} onChange={set("deluxeRooms")} />
              </Field>
              <Field label="Suite rooms" optional>
                <FocusInput placeholder="count" value={form.suiteRooms} onChange={set("suiteRooms")} />
              </Field>
            </div>
            <div style={s.row2}>
              <Field label="Number of sharing rooms" optional>
                <FocusInput placeholder="count" value={form.sharingRooms} onChange={set("sharingRooms")} />
              </Field>
              <Field label="Number of isolation rooms" optional>
                <FocusInput placeholder="count" value={form.isolationRooms} onChange={set("isolationRooms")} />
              </Field>
            </div>
            <div style={s.row3}>
              <Field label="MICU beds" optional>
                <FocusInput placeholder="count, if required" value={form.micuBeds} onChange={set("micuBeds")} />
              </Field>
              <Field label="PICU beds" optional>
                <FocusInput placeholder="count, if required" value={form.picuBeds} onChange={set("picuBeds")} />
              </Field>
              <Field label="NICU beds" optional>
                <FocusInput placeholder="count, if required" value={form.nicuBeds} onChange={set("nicuBeds")} />
              </Field>
            </div>
          </div>

          {/* 4. Outpatient & emergency */}
          <div style={s.section}>
            <div style={s.sectionLabel}>4. Outpatient & emergency</div>
            <div style={s.row2}>
              <Field label="Number of OPD consultation rooms" optional>
                <FocusInput placeholder="e.g. 6" value={form.opdRooms} onChange={set("opdRooms")} />
              </Field>
              <Field label="Casualty / emergency beds" optional>
                <FocusInput placeholder="e.g. 3–6" value={form.emergencyBeds} onChange={set("emergencyBeds")} />
              </Field>
            </div>
          </div>

          {/* 5. Operation theatres */}
          <div style={s.section}>
            <div style={s.sectionLabel}>5. Operation theatres (OT)</div>
            <div style={s.row1}>
              <Field label="How many operation theatres are required?" optional>
                <FocusInput placeholder="e.g. 2" value={form.totalOT} onChange={set("totalOT")} />
              </Field>
            </div>
            <div style={s.row3}>
              <Field label="Laminar OT" optional>
                <FocusInput placeholder="count" value={form.laminarOT} onChange={set("laminarOT")} />
              </Field>
              <Field label="Modular OT" optional>
                <FocusInput placeholder="count" value={form.modularOT} onChange={set("modularOT")} />
              </Field>
              <Field label="Minor OT" optional>
                <FocusInput placeholder="count" value={form.minorOT} onChange={set("minorOT")} />
              </Field>
            </div>
          </div>

          {/* 6. Diagnostics & support services */}
          <div style={s.section}>
            <div style={s.sectionLabel}>6. Diagnostics & support services</div>
            <Field label="Radiology requirements" optional>
              <CheckGroup options={RADIOLOGY_OPTIONS} selected={radiology} onToggle={toggleRadiology} columns={3} />
            </Field>
            <div style={{ marginTop: 8, marginBottom: 14 }}>
              <Field label="Any others" optional>
                <FocusInput placeholder="e.g. Physio" value={form.otherRadiology} onChange={set("otherRadiology")} />
              </Field>
            </div>
            <div style={{ marginBottom: 14 }}>
              <Field label="Laboratory facilities" optional>
                <CheckGroup options={LAB_OPTIONS} selected={labs} onToggle={toggleLab} columns={3} />
              </Field>
            </div>
            <Field label="Pharmacy" optional>
              <CheckGroup options={PHARMACY_OPTIONS} selected={pharmacy} onToggle={togglePharmacy} columns={3} />
            </Field>
          </div>

          {/* 7. Non-clinical areas */}
          <div style={s.section}>
            <div style={s.sectionLabel}>7. Non-clinical areas</div>
            <CheckGroup options={NON_CLINICAL_OPTIONS} selected={nonClinical} onToggle={toggleNonClinical} columns={2} />
          </div>

          {/* 8. Parking & circulation */}
          <div style={s.section}>
            <div style={s.sectionLabel}>8. Parking & circulation</div>
            <div style={s.row3}>
              <Field label="Cars" optional>
                <FocusInput placeholder="count" value={form.parkingCars} onChange={set("parkingCars")} />
              </Field>
              <Field label="Bikes" optional>
                <FocusInput placeholder="count" value={form.parkingBikes} onChange={set("parkingBikes")} />
              </Field>
              <Field label="Ambulances" optional>
                <FocusInput placeholder="count" value={form.parkingAmbulances} onChange={set("parkingAmbulances")} />
              </Field>
            </div>
          </div>

          {/* Consultation details */}
          <div style={s.section}>
            <div style={s.sectionLabel}>Consultation details</div>
            <div style={{ ...s.row1, marginBottom: "0.875rem" }}>
              <Field label="Service type" required error={errors.service}>
                <FocusInput as="select" id="cf_service" value={form.service} onChange={set("service")} hasError={!!errors.service}>
                  {SERVICES.map((sv) => (
                    <option key={sv.value} value={sv.value} disabled={sv.value === ""}>{sv.label}</option>
                  ))}
                </FocusInput>
              </Field>
            </div>
            <div style={s.row2}>
              <Field label="Preferred date" required error={errors.date}>
                <FocusInput id="cf_date" type="date" value={form.date} onChange={set("date")} hasError={!!errors.date}
                  min={new Date().toISOString().split("T")[0]} />
              </Field>
              <Field label="Preferred time" required error={errors.time}>
                <FocusInput as="select" id="cf_time" value={form.time} onChange={set("time")} hasError={!!errors.time}>
                  <option value="">Select a slot</option>
                  {TIME_SLOTS.map((t) => <option key={t}>{t}</option>)}
                </FocusInput>
              </Field>
            </div>
            <div style={s.row1}>
              <Field label="Meeting format" required error={errors.mode}>
                <FocusInput as="select" id="cf_mode" value={form.mode} onChange={set("mode")} hasError={!!errors.mode}>
                  <option value="">Select a format</option>
                  {MEETING_FORMATS.map((m) => <option key={m}>{m}</option>)}
                </FocusInput>
              </Field>
            </div>
          </div>

          {/* Budget & scope */}
          <div style={s.section}>
            <div style={s.sectionLabel}>Budget & scope</div>
            <div style={{ marginBottom: "1.25rem" }}>
              <Field label={<>Estimated budget <span style={s.budgetChip}>{BUDGET_LABELS[form.budget]}</span></>}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 6 }}>
                  <span style={{ fontSize: 11.5, color: "#bbb" }}>₹0</span>
                  <input type="range" min={0} max={4} step={1} value={form.budget}
                    onChange={set("budget")}
                    style={{ flex: 1, accentColor: "#1a1a1a", cursor: "pointer" }} />
                  <span style={{ fontSize: 11.5, color: "#bbb" }}>₹5L+</span>
                </div>
                <div style={s.budgetLabels}>
                  {BUDGET_LABELS.map((l) => <span key={l}>{l}</span>)}
                </div>
              </Field>
            </div>
            <Field label={<>Topics to discuss <span style={s.optText}>(select all that apply)</span></>}>
              <CheckGroup
                options={TOPICS}
                selected={TOPICS.filter((_, i) => topics[i])}
                onToggle={(opt) => toggleTopic(TOPICS.indexOf(opt))}
                columns={2}
              />
            </Field>
          </div>

          {/* Message */}
          <div style={{ ...s.section, marginBottom: 0 }}>
            <div style={s.sectionLabel}>Your message</div>
            <Field label="Describe your project or requirements" optional>
              <FocusInput
                as="textarea"
                placeholder="Give us a brief overview of your hospital setup and what you'd like to discuss…"
                value={form.message}
                onChange={(e) => { if (e.target.value.length <= 500) set("message")(e); }}
              />
            </Field>
            <div style={s.charCount}>{form.message.length} / 500</div>
          </div>

        </div>

        <div style={s.footer}>
          <div style={s.footerNote}>
            <span>🔒</span> Sent securely to hospitalsdesigners@gmail.com
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: loading ? "#555" : "#111", color: "#fff",
              border: "none", padding: "10px 26px", borderRadius: 8,
              fontSize: 13.5, fontWeight: 600, cursor: loading ? "wait" : "pointer",
              fontFamily: "'Poppins',sans-serif", transition: "background 0.15s", minWidth: 148,
            }}
          >
            {loading ? "Sending…" : "Submit request →"}
          </button>
        </div>

      </div>
    </>
    </>
  );
}
